import { render, staticRenderFns } from "./list.vue?vue&type=template&id=4b0ad6f8&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=4b0ad6f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_babel-core@7.0.0-bridge.0_@babel+core@7.29._1a562a7ff44e47125e24b47fdbb3ae4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0ad6f8",
  null
  
)

export default component.exports